import Vue from 'vue';
import App from './App.vue';
import config from './LoginWrapperConfig';

Vue.config.productionTip = false;

const mountEl = document.querySelector('#' + config.mountPointId) as any;
const props = mountEl !== null ? { ...mountEl.dataset, mountPointId: config.mountPointId } : {};

new Vue({
  render: (createElement) => {
    const context = {
      props,
    };

    return createElement(App, context);
  },
}).$mount('#' + config.mountPointId);
